module.exports = __webpack_public_path__ + "static/carmen_graves-89798e53643cf0d55d17dc0acaeecd54.png";